module.exports = __webpack_public_path__ + "static/media/SmallCircleLoader.8162d67c.svg";